import { USER_TYPE, ADMIN_TYPE } from '../contants'

export default {
  name: 'Admin',
  functional: true,
  render (h, { scopedSlots, parent }) {
    const result =
      parent.$store.state.loginUser.isAdmin === ADMIN_TYPE.on &&
      parent.$store.state.loginUser.type === USER_TYPE.super
    return result ? scopedSlots.default() : null
  }
}
